module.exports = __webpack_public_path__ + "static/img/4.c1e2308.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carousel-2/4.jpg
// module id = kfbq
// module chunks = 1